
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoashtavinayakcab() {



    const cardData =
    {
        keyword: 'Pune to Ashtavinayak Cab',
        heading: 'Meghana Cab : Pune to Ashtavinayak Cab',
        headingDescription: 'Meghana Cab offers Pune to Ashtavinayak Cab services, delivering a serene, convenient, and spiritually enriching journey to the revered Ashtavinayak temples. Whether you are embarking on a pilgrimage tour, family trip, or a peaceful retreat, our clean and well-maintained cabs with experienced drivers ensure a smooth and timely ride. Choose from a variety of vehicle options—hatchbacks, sedans, SUVs, or tempo travellers—to accommodate your group size and preferences. Enjoy transparent pricing, punctual pickups, and 24/7 customer support. Book your Pune to Ashtavinayak Cab with Meghana Cab and immerse yourself in devotion and tranquility with comfort and ease.',


        top: 'Top Places to Visit in Ashtavinayak with Meghana Cab',

"topPlaces": [
  {
    "title": "Moreshwar Temple, Morgaon",
    "description": "Considered the first and last stop of the Ashtavinayak pilgrimage, this temple houses the svayambhu idol of Mayureshwar (Ganesha on a peacock). Located on the Karha River bank, it is the spiritual center of the Ganapatya sect and linked to sage Moraya Gosavi. The site's medieval architecture, ritual traditions, and Peshwa-era patronage make it a profound pilgrimage experience."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Perched on a small hill along the Bhima River, this temple features the fierce right-trunked idol of Siddhivinayak. According to lore, Lord Vishnu was granted victory over demons here. Devotees circumambulate the temple seeking success and spiritual power. Its riverside location enhances its serenity and mythic atmosphere."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Unique among the eight, this temple is named after the devotee Ballal. The shrine stands near Sarasgad Fort and depicts a narrative where young Ballal’s devotion moved Ganesha to appear and bless him. The relaxed hillscape, caves nearby, and regional rustic charm add depth to its spiritual aura."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Situated in Raigad district, this shrine venerates Varadvinayak—the Giver of Boons. Legend says Lord Ganesha cured King Rukmangada of leprosy here. Set amid cashew orchards and coastal hills, the temple draws those seeking fulfillment and relief from ailments."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "Associated with sage Kapila and the wish‑granting Chintamani gem, Ganesha retrieved the gem from his adversaries here. The large east-facing idol in this temple, rebuilt by Peshwa Madhavrao, stands in a hall with water fountains and Peshwa-era relics. Pilgrims visit to overcome worries and seek clarity."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "Housed inside a Buddhist cave complex, this temple represents the birth of Ganesha to Goddess Parvati (Girija). Carved into the rock face in Junnar, the self‑emanated idol with left‑turning trunk overlooks a fortified hillside. The ascent through ancient rock‑cut steps lends an atmospheric and contemplative journey."
  },
  {
    "title": "Vigneshwara Temple, Ozar",
    "description": "This shrine honors Vigneshwara—Remover of Obstacles—and commemorates the defeat of the demon Vignasura. The gold‑topped shikhara was renovated by Chimaji Appa, and the emerald eyes and diamond ornamentation of the self‑manifest idol are renowned. Pilgrims collect oil at the river confluence to light lamps as blessings."
  },
  {
    "title": "Mayureshwar Mayureshwar Temple, Morgaon",
    "description": "A repeat visit to the Morgaon temple completes the full Ashtavinayak cycle. Returning here symbolizes spiritual renewal and closure. Many pilgrims perform a second pradakshina (circumambulation) and seek darshan again before concluding the journey."
  }
],

    "services": [
    {
      "name": "Ashtavinayak Darshan Cab from Pune",
      "description": "Book comfortable and reliable cabs from Pune to visit all the eight sacred Ashtavinayak temples. Enjoy hassle-free travel with well-maintained vehicles, professional drivers, and flexible packages tailored to your pilgrimage needs."
    },
    {
      "name": "One Way Pune to Ashtavinayak Cab",
      "description": "Looking for a convenient one-way taxi from Pune to Ashtavinayak temples? Our service guarantees timely pickups, clean and AC vehicles, and experienced drivers to ensure a smooth and safe journey to your destination."
    },
    {
      "name": "Round Trip Cab Pune to Ashtavinayak Temples",
      "description": "Plan your entire Ashtavinayak pilgrimage with our round trip cab services. Whether it's a day trip or multiple days, our flexible packages, courteous drivers, and well-maintained fleet provide an affordable and comfortable travel experience."
    },
    {
      "name": "Pune to Ashtavinayak Pilgrimage Cab",
      "description": "Embark on a spiritual journey from Pune to the Ashtavinayak temples with Meghana Cab. We offer reliable vehicles and knowledgeable drivers familiar with the routes and local customs to enrich your pilgrimage."
    },
    {
      "name": "AC Cab Hire Pune to Ashtavinayak",
      "description": "Travel in comfort with our air-conditioned cabs from Pune to Ashtavinayak temples. Beat the heat and enjoy a relaxing ride while focusing on your spiritual experience."
    },
    {
      "name": "Pune to Ashtavinayak Route Cab",
      "description": "Discover the best route for your Ashtavinayak temple tour with expert drivers who know all shortcuts and scenic spots. Our cab service ensures timely arrivals and smooth navigation throughout your pilgrimage."
    },
    {
      "name": "Book Online Taxi Pune to Ashtavinayak",
      "description": "Enjoy the ease of booking your Pune to Ashtavinayak taxi online. Choose your vehicle, schedule your pickup, and confirm your trip within minutes — all through a safe and user-friendly platform."
    },
    {
      "name": "Budget Travel Cab Pune to Ashtavinayak",
      "description": "Make your pilgrimage affordable without compromising on safety or comfort. Our budget-friendly cabs from Pune to Ashtavinayak offer great value with clean vehicles and professional service."
    },
    {
      "name": "SUV Taxi for Ashtavinayak Tour",
      "description": "Travel comfortably with family or friends in our spacious SUVs. Perfect for group pilgrimages to Ashtavinayak temples, our SUVs provide ample space for luggage and passengers, ensuring a relaxing journey."
    },
    {
      "name": "Ashtavinayak Mandir Trip by Cab Pune",
      "description": "Plan your Ashtavinayak mandir trip with confidence. Our well-maintained cabs and courteous drivers make your temple visits hassle-free and enjoyable."
    },
    {
      "name": "Sedan Hire Pune to Ashtavinayak Temples",
      "description": "Opt for our sedan hire service for a comfortable and budget-conscious ride from Pune to the Ashtavinayak temples. Ideal for solo travelers, couples, or small families."
    },
    {
      "name": "Family Cab Pune to Ashtavinayak Tour",
      "description": "Make your family pilgrimage special with our family-friendly cabs. Spacious vehicles, safe driving, and flexible itineraries ensure a memorable Ashtavinayak tour from Pune."
    },
    {
      "name": "Pune to Ashtavinayak Darshan by Car",
      "description": "Enjoy a personalized and private darshan trip with chauffeur-driven cars. Relax while we handle the driving and navigation as you focus on your spiritual journey."
    },
    {
      "name": "Group Cab Pune to Ashtavinayak",
      "description": "Ideal for larger groups traveling together, our group cab services offer comfortable seating, luggage space, and professional drivers experienced in group travel logistics."
    },
    {
      "name": "Chauffeur Driven Cab for Ashtavinayak Yatra",
      "description": "Experience hassle-free travel with our chauffeur-driven cabs. Our professional drivers are courteous, punctual, and well-versed with the Ashtavinayak yatra routes to ensure your journey is smooth and stress-free."
    }
  ],
  "tableData": [
    ["Ashtavinayak Darshan Cab from Pune", "One Way Pune to Ashtavinayak Cab"],
    ["Round Trip Cab Pune to Ashtavinayak Temples", "Pune to Ashtavinayak Pilgrimage Cab"],
    ["AC Cab Hire Pune to Ashtavinayak", "Pune to Ashtavinayak Route Cab"],
    ["Book Online Taxi Pune to Ashtavinayak", "Budget Travel Cab Pune to Ashtavinayak"],
    ["SUV Taxi for Ashtavinayak Tour", "Ashtavinayak Mandir Trip by Cab Pune"],
    ["Sedan Hire Pune to Ashtavinayak Temples", "Family Cab Pune to Ashtavinayak Tour"],
    ["Pune to Ashtavinayak Darshan by Car", "Group Cab Pune to Ashtavinayak"],
    ["Chauffeur Driven Cab for Ashtavinayak Yatra", ""]
  ],








"whychoose": [
    {
        "WhyChooseheading": "Dedicated Pune to Ashtavinayak Cab Service",
        "WhyChoosedescription": "Meghana Cab offers specialized cab services for the sacred Ashtavinayak Yatra, covering all eight revered Ganpati temples in Maharashtra. Our Pune to Ashtavinayak cab ensures a spiritual, comfortable, and well-planned pilgrimage experience."
    },
    {
        "WhyChooseheading": "Complete Ashtavinayak Darshan Package",
        "WhyChoosedescription": "We provide full-day and multi-day Ashtavinayak cab packages from Pune, covering Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon. Enjoy the complete circuit without any stress—our team takes care of the route, timing, and logistics."
    },
    {
        "WhyChooseheading": "Affordable Pilgrimage Cab Fare with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to Ashtavinayak cab fare is affordable and transparent, including fuel, tolls, driver allowance, and taxes. Get complete clarity upfront and choose from flexible fare options based on vehicle type and duration."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Long Travel",
        "WhyChoosedescription": "Choose from well-maintained sedans, spacious SUVs, and tempo travellers depending on your group size. All vehicles are sanitized, air-conditioned, and perfect for covering long distances over one or two days."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Temple Routes",
        "WhyChoosedescription": "Our drivers have in-depth knowledge of the Ashtavinayak route, temple timings, and the best darshan schedules. They help optimize your itinerary for a smooth and timely visit to all eight temples."
    },
    {
        "WhyChooseheading": "Flexible One-Day and Two-Day Tour Options",
        "WhyChoosedescription": "We offer both one-day express and two-day relaxed Ashtavinayak cab tours from Pune. You can customize the trip to include halts, overnight stays, or additional temple visits along the way."
    },
    {
        "WhyChooseheading": "24/7 Booking and Dedicated Support",
        "WhyChoosedescription": "Plan your pilgrimage anytime with our 24/7 booking support. Whether it’s a weekday or festival time, Meghana Cab ensures prompt service, verified drivers, and real-time assistance throughout your yatra."
    },
    {
        "WhyChooseheading": "Ideal for Families, Seniors & Devotee Groups",
        "WhyChoosedescription": "Our Ashtavinayak cab packages are tailored for family groups, elderly passengers, and spiritual seekers. We prioritize comfort, punctuality, and a peaceful environment throughout the journey."
    }
]





































    }

const faqData = [
    {
        question: "How can I book a cab for the Ashtavinayak Darshan from Pune with Meghana Cab?",
        answer: "You can book your Pune to Ashtavinayak cab by calling Meghana Cab at +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "Which vehicle options are available for the Pune to Ashtavinayak Yatra?",
        answer: "We offer comfortable sedans, spacious SUVs, and tempo travellers for families or groups based on your requirement."
    },
    {
        question: "Are your drivers familiar with the Ashtavinayak temple routes?",
        answer: "Yes, our experienced drivers are well-versed with all eight temple locations and routes for a smooth pilgrimage experience."
    },
    {
        question: "Do you provide a one-day or multi-day package for the Ashtavinayak trip?",
        answer: "Yes, we offer both one-day and two-day packages. Custom itineraries can also be arranged based on your preferences."
    },
    {
        question: "Is the cab fare inclusive of all tolls and driver charges for Ashtavinayak Darshan?",
        answer: "Our package fare includes driver charges, fuel, and tolls. Any parking or extra waiting time may incur additional charges."
    },
    {
        question: "Are Meghana Cab vehicles sanitized before the Ashtavinayak trip?",
        answer: "Yes, all vehicles are sanitized thoroughly before every trip to ensure your safety and hygiene."
    },
    {
        question: "Is the cab service available 24/7 for Pune to Ashtavinayak bookings?",
        answer: "Yes, we operate round-the-clock to match your travel and temple visit timings."
    },
    {
        question: "Can we request halts for meals or sightseeing during the trip?",
        answer: "Yes, halts can be accommodated on request. Please inform us during booking to plan accordingly."
    },
    {
        question: "What payment methods are accepted for the Pune to Ashtavinayak cab service?",
        answer: "We accept UPI, credit/debit cards, bank transfers, and cash."
    },
    {
        question: "How do I contact Meghana Cab to plan my Ashtavinayak Darshan?",
        answer: "Call us at +91 9075462128 to book your cab or get itinerary assistance for your Ashtavinayak trip."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Ashtavinayak Darshan with Meghana Cab was peaceful and well-organized. The driver knew all temple routes perfectly.”',
    },
    {
        name: 'Mrs. Aarti Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided excellent service for our family Ashtavinayak Yatra. The car was clean and the journey was comfortable.”',
    },
];










































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const ashtavinayakCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Ashtavinayak Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-ashtavinayak-cab.jpg",
  "description": "Book comfortable and affordable Pune to Ashtavinayak pilgrimage cabs with Meghana Cabs. One way and round trip taxi services with AC cars, SUVs, family and group travel options.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "One Way Pune to Ashtavinayak Cab",
    "Round Trip Cab Pune to Ashtavinayak Temples",
    "AC Cab Hire Pune to Ashtavinayak",
    "SUV Taxi for Ashtavinayak Tour",
    "Family Cab Pune to Ashtavinayak Tour"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Ashtavinayak Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Pune to Ashtavinayak Cab"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Pune to Ashtavinayak Temples"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SUV Taxi for Ashtavinayak Tour"
        }
      }
    ]
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Ashtavinayak Cab | Pilgrimage Taxi Service </title>
  <meta
    name="description"
    content="Book comfortable and affordable Pune to Ashtavinayak pilgrimage cabs with Meghana Cabs. One way and round trip taxi services with AC cars, SUVs, family and group travel options."
  />
  <meta
    name="keywords"
    content="Ashtavinayak Darshan Cab from Pune, One Way Pune to Ashtavinayak Cab, Round Trip Cab Pune to Ashtavinayak Temples, Pune to Ashtavinayak Pilgrimage Cab, AC Cab Hire Pune to Ashtavinayak, Pune to Ashtavinayak Route Cab, Book Online Taxi Pune to Ashtavinayak, Budget Travel Cab Pune to Ashtavinayak, SUV Taxi for Ashtavinayak Tour, Ashtavinayak Mandir Trip by Cab Pune, Sedan Hire Pune to Ashtavinayak Temples, Family Cab Pune to Ashtavinayak Tour, Pune to Ashtavinayak Darshan by Car, Group Cab Pune to Ashtavinayak, Chauffeur Driven Cab for Ashtavinayak Yatra"
  />
  <script type="application/ld+json">
    {JSON.stringify(ashtavinayakCabSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/43.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoashtavinayakcab;